import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useSession } from "@/features/auth/useSession";

export type Membership = {
  id: string;
  organization_id: string;
  role: "owner" | "admin" | "agent" | "viewer";
  organizations: {
    id: string;
    name: string;
    slug: string;
    siret: string | null;
    vat_number: string | null;
    address: string | null;
    accounting_email: string | null;
  } | null;
};

export function useMyMembership() {
  const { user } = useSession();

  return useQuery({
    queryKey: ["my-membership", user?.id],
    enabled: Boolean(user),
    queryFn: async (): Promise<Membership | null> => {
      const { data, error } = await supabase
        .schema("app")
        .from("memberships")
        .select(
          "id, organization_id, role, organizations(id, name, slug, siret, vat_number, address, accounting_email)",
        )
        .eq("user_id", user!.id)
        .order("created_at", { ascending: true })
        .limit(1)
        .maybeSingle<Membership>();

      if (error) throw error;
      return data;
    },
  });
}
